import { useEffect } from "react";
import { getPructureProtectionApi } from "features/mst_option/api/optionApi";
import { getQuoteByListApi } from "features/quotation/api/quotationListApi";
import { PunctureProtection } from "features/mst_option/types/option";
import { TblQuoteBy } from "features/quotation/types/quotation";

/**
 * Callbacks for initial data loader
 */
interface InitialDataCallbacks {
  onPunctureProtectionLoaded: (data: PunctureProtection[]) => void;
  onQuoteByListLoaded: (data: { label: string }[]) => void;
}

/**
 * Custom hook to load all initial API data in parallel
 * @param callbacks - Callbacks to handle loaded data
 */
const useInitialDataLoader = (callbacks: InitialDataCallbacks) => {
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [punctureRes, quoteByRes] = await Promise.all([
          getPructureProtectionApi(),
          getQuoteByListApi(),
        ]);

        // Set puncture protection (sorted)
        if (punctureRes.list) {
          const sortedList = punctureRes.list.sort(
            (a: { coverage_amount_low: number }, b: { coverage_amount_low: number }) =>
              a.coverage_amount_low - b.coverage_amount_low,
          );
          callbacks.onPunctureProtectionLoaded(sortedList);
        }

        // Set quote by list
        if (quoteByRes.list?.length > 0) {
          const formattedList = quoteByRes.list.map((item: TblQuoteBy) => ({
            label: item.quote_by,
          }));
          callbacks.onQuoteByListLoaded(formattedList);
        }
      } catch (error) {
        // Silently handle error
      }
    };

    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount
};

export { useInitialDataLoader };
export default useInitialDataLoader;
